import { AUTO_RETRY } from 'src/modules/error-helper';

import { taskManager } from './taskManager';

const createIsRetryable =
  ({ classifyError, retryCount }) =>
  (error, attemptCount) =>
    classifyError(error) === AUTO_RETRY && attemptCount < retryCount;

const classifyTaskError = (
  isRetryable,
  { action, payload, attemptCount = 0 },
  error,
) => ({
  action,
  payload,
  canRetry: isRetryable(error, attemptCount),
  attemptCount: attemptCount + 1,
});

const update = (isRetryable, pendingUpdate) => {
  const currUpdate = pendingUpdate.pop();
  return currUpdate
    .action(currUpdate.payload, currUpdate.store)
    .catch((e) => {
      const taskWithError = classifyTaskError(isRetryable, currUpdate, e);

      if (pendingUpdate.empty() && !taskWithError.canRetry) {
        throw e;
      }

      if (pendingUpdate.empty()) {
        pendingUpdate.add(taskWithError);
      }

      return update(isRetryable, pendingUpdate);
    })
    .then((value) => {
      if (!pendingUpdate.empty()) {
        return update(isRetryable, pendingUpdate);
      }

      return value;
    });
};

export const updater = (options) => {
  let locked = false;
  const pendingUpdate = taskManager();

  return (action, payload, store) => {
    pendingUpdate.add({ action, payload, store });

    if (!locked) {
      locked = true;

      return update(createIsRetryable(options), pendingUpdate)
        .then((value) => {
          locked = false;
          return value;
        })
        .catch((e) => {
          locked = false;
          throw e;
        });
    }

    return null;
  };
};
